import { codeSplit, Controller, FetchOptions, FetchPageOptions, AnalyticsStore, PageStore } from "bernie-core";
import { PageData } from "bernie-http";
import { FlexViewModelStore } from "stores/flexViewModel/FlexViewModelStore";
import { Composition, ExtendedContextStore, ViewModelResponse } from "typings/flexFramework/FlexDefinitions";
import { CookiesStore } from "stores/CookiesStore";
import { StaticMapStore } from "stores/staticMap/StaticMapStore";
import { CompositionStore } from "src/stores/CompositionStore";
import { FlexModuleStore } from "src/stores/FlexModuleStore";
import { BlossomCodeSplitterFactory } from "components/flexFramework/CodeSplitter/BlossomCodeSplitterFactory";

interface WindowWithState extends Window {
  __STATE__: {
    compositionStore: CompositionStore;
  };
}

declare var window: WindowWithState;

interface FlexFetchPageOptions extends FetchPageOptions {
  context: ExtendedContextStore;
}

export class MockModuleController implements Controller {
  public pageId = "mockModuleLanding";
  public path = "/render/module/test";
  public routeName = "flex-MockLandingPage";
  public bundles = ["flex-MockLandingPage"];
  public exact = false;

  public component = codeSplit(async () => {
    const routeComponent = import(/* webpackChunkName: "flex-MockLandingPage" */ "views/MockLandingPage") as any;
    let composition: Composition | undefined;

    if (typeof window !== "undefined") {
      const serializedState = window.__STATE__;
      composition =
        serializedState && serializedState.compositionStore ? serializedState.compositionStore.composition : undefined;
    }

    await BlossomCodeSplitterFactory.get({ composition }).codeSplitAllReactComponents();

    return routeComponent;
  });

  public fetch(options: FetchOptions): Promise<any> {
    const { stores, request } = options;
    const flexViewModelStore = stores && stores.get<FlexViewModelStore>("flexViewModel");
    const pageStore = stores && stores.get<PageStore>("page");
    const contextStore = stores && stores.get<ExtendedContextStore>("context");
    const cookiesStore = stores && stores.get<CookiesStore>("cookies");
    const staticMapStore = stores && stores.get<StaticMapStore>("staticMap");
    const compositionStore = stores && stores.get<CompositionStore>("compositionStore");
    const flexModuleStore = stores && stores.get<FlexModuleStore>("flexModuleStore");
    const analyticsStore = stores && stores.get<AnalyticsStore>("analytics");

    // Get cookie string for wizard
    cookiesStore.cookie = (request && request.headers && request.headers.cookie) || "";

    const viewModelResponse = contextStore.viewModelResponse as ViewModelResponse;
    const footer: string = contextStore.footer;

    flexViewModelStore.setupFlexViewModelStore(viewModelResponse, pageStore, contextStore, analyticsStore, footer);

    compositionStore.setup(viewModelResponse, contextStore, flexModuleStore, staticMapStore);

    return Promise.resolve({});
  }

  public fetchPageData(options: FlexFetchPageOptions): Promise<PageData> {
    const viewModelResponse = options.context.viewModelResponse as ViewModelResponse;
    const additionalScripts = BlossomCodeSplitterFactory.get({
      composition: viewModelResponse.composition,
    })
      .getWebpackReactComponents()
      .map((component) => component && component.webpackChunkName);

    const seoMetaData = import(/* webpackChunkName: "SeoUtils" */ "utils/seo/SeoUtils").then(({ default: _ }) => {
      return (
        _.buildPageDataWithSeoMetaDataFromViewModel(viewModelResponse) || {
          title: viewModelResponse.composition.title,
        }
      );
    });

    // Basically giving a list of webpackChunkNames that we want
    return Promise.resolve(seoMetaData).then((m) => {
      return {
        ...m,
        assetsToIncludeFilter: (assetKey: string) => additionalScripts.includes(assetKey),
      };
    });
  }
}
